import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import Utils from "models/helper/Utils";
import PersistentModels from "services/PersistentModels";
import RSVP from "rsvp";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import ti18n from "i18n!nls/EditUserInfoi18n";
import EditUserInfoPageView from "views/user/EditUserInfoPageView";


const EditUserInfoPageController =  Chaplin.Controller.extend({


    initialize : function(options) {
        _.extend(this, Backbone.Events);
        this.model = null;
        this._pageId = options.pageId;
        this._onUserPorfileChanged =  options.onUserPorfileChanged;
        
    },
    
    getModel : function(){
        return this.model;
    },
    
    getView : function(){
        return this.view;
    },

    validatUsername : function(username){
        let errorMessage =  null;
        if(!username){
            errorMessage  = window.getI18n(ti18n, "USERNAME_CANNOT_BE_EMPTY");
        }else{
            if(username && username.length > Utils.getInstance().getMaxNumberOfCharForUsername() && username.length < Utils.getInstance().getMinNumberOfCharForUsername()){
                errorMessage = window.getI18n(ti18n, "USERNAME_VALIDATION_ERROR");
            }
            if(!username.match(Utils.getInstance().getUsernameRegexValidation())){
                errorMessage = window.getI18n(ti18n, "USERNAME_CAN_ONLY_CONTAIN_CHARACTERS");
            }
        }
        const isValid = !errorMessage;
        this.view.setUsernameValid(isValid, errorMessage);
        if(isValid){
            return TrebbleClientAPIHelper.getInstance().isUserWithSameUsername(username,this.model.getUserId()).then((function(alreadyExists){
                if(alreadyExists){
                    this.view.setUsernameValid(false, window.getI18n(ti18n, "USERNAME_ALREADY_TAKEN"));
                }
                return !alreadyExists;
            }).bind(this));
        }else{
            return RSVP.Promise.resolve(isValid);
        }
        return isValid;
    },

    validatEmail : function(emailValue){
        const re = Utils.getInstance().getEmailRegexValidation();
        let isValid = re.test(emailValue);
        let errorMessage ;
        if(!re.test(emailValue)) {
            errorMessage = window.getI18n(ti18n, "INVALID_EMAIL");
            
        } 
        isValid = !errorMessage;
        this.view.setEmailValid(isValid, errorMessage);
        if(isValid){
            return TrebbleClientAPIHelper.getInstance().isUserWithSameEmail(emailValue,this.model.getUserId()).then((function(alreadyExists){
                if(alreadyExists){
                    this.view.setEmailValid(false, window.getI18n(ti18n, "EMAIL_ALREADY_TAKEN"));
                }
                return !alreadyExists;
            }).bind(this));
        }else{
            return RSVP.Promise.resolve(isValid);
        }
        return isValid;
    },

    
    saveChanges : function(dataToChange){
        
        $.mobile.loading("show");
        
        return TrebbleClientAPIHelper.getInstance().updateLoggedInUserProfile(dataToChange).then((function(updateResult){
            const emailChangePending = updateResult ? updateResult.emailChangePending : null;
            if(emailChangePending){
                // The code is already on its way: show the code step now, whatever happens to the
                // profile refresh below. Inline, not a modal alert, which would cover the code field.
                $.mobile.loading("hide");
                this._emailChangeConfirmed = false;
                this._pendingEmailChangeUsername = dataToChange.username;
                this.view.openEmailChangeVerificationPanel(emailChangePending.email);
                // Confirming returns the whole profile; cancelling refreshes it again if this one fails.
                this.refreshSavedProfile(dataToChange.username).catch(function(){});
                return null;
            }
            return TrebbleClientAPIHelper.getInstance().getUserProfileInfoByUsername(dataToChange.username).then(function(updatedUserInfo){
                return { updatedUserInfo: updatedUserInfo, updateResult: updateResult };
            });
        }).bind(this)).then((function(saveResult){
            if(!saveResult){
                return;
            }
            const updatedUserInfo = saveResult.updatedUserInfo;
            LocalStorageHelper.getInstance().updateUserInfo(updatedUserInfo);
            this._onUserPorfileChanged? this._onUserPorfileChanged(updatedUserInfo): null;
            this.view.navigateToPreviousPage();
            // A server without the code step (before TrebbleNodeServer #2066) changes the email at once
            // and asks for verification at the next sign-in: say so, as production has since August.
            let successMessage = window.getI18n(ti18n, "YOUR_PROFILE_WAS_UPDATED");
            const updateResult = saveResult.updateResult;
            if(updateResult && updateResult.requiresEmailVerification){
                const verificationMessageKey = updateResult.verificationEmailSent ? "EMAIL_UPDATED_VERIFY_NEW_EMAIL" : "EMAIL_UPDATED_VERIFY_NEW_EMAIL_ON_NEXT_SIGN_IN";
                successMessage = window.getI18n(ti18n, verificationMessageKey).replace("{email}", dataToChange.email.trim());
            }
            window.alertSuccessMessage(successMessage);
            $.mobile.loading("hide");
        }).bind(this)).catch((function(error){
            $.mobile.loading("hide");
            this.view.setSaveButtonEnabled(true);
            const errorMessage = error? error:window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHEN_SAVING_YOUR_CHANGES");
            window.alertErrorMessage(errorMessage);
        }).bind(this));
        
        
    },

    // The other fields were saved along with the pending email: keep the stored profile in step.
    refreshSavedProfile : function(username){
        return TrebbleClientAPIHelper.getInstance().getUserProfileInfoByUsername(username).then((function(updatedUserInfo){
            // A refresh that lands after the code was confirmed still carries the old email.
            if(this._emailChangeConfirmed){
                return;
            }
            LocalStorageHelper.getInstance().updateUserInfo(updatedUserInfo);
            this._onUserPorfileChanged? this._onUserPorfileChanged(updatedUserInfo): null;
        }).bind(this));
    },

    verifyEmailChange : function(code){
        this.view.setEmailChangeVerificationButtonEnabled(false);
        return TrebbleClientAPIHelper.getInstance().confirmMyEmailChange(code).then((function(result){
            this._emailChangeConfirmed = true;
            const updatedUserInfo = result.userInfo;
            LocalStorageHelper.getInstance().updateUserInfo(updatedUserInfo);
            this._onUserPorfileChanged? this._onUserPorfileChanged(updatedUserInfo): null;
            this.view.closeEmailChangeVerificationPanel();
            // Going back from a page already left would navigate the person away a second time.
            if(this.view.isPageActive()){
                this.view.navigateToPreviousPage();
            }
            window.alertSuccessMessage(window.getI18n(ti18n, "EMAIL_CHANGE_CONFIRMED"));
        }).bind(this)).catch((function(error){
            const errorMessage = error && (error.errorMessage || error.message) ?
                (error.errorMessage || error.message) : window.getI18n(ti18n, "EMAIL_CHANGE_VERIFY_FAILED");
            this.view.setEmailChangeVerificationError(errorMessage);
            this.view.setEmailChangeVerificationButtonEnabled(true);
        }).bind(this));
    },

    cancelEmailChange : function(){
        // Close only once the server has dropped the pending email: a new save racing an unfinished
        // cancellation could otherwise have its own pending email cancelled.
        this.view.setEmailChangeVerificationError(null);
        this.view.setEmailChangeVerificationButtonEnabled(false);
        return TrebbleClientAPIHelper.getInstance().cancelMyEmailChange().then((function(){
            // The refresh after saving may have failed; without it the saved fields would look reverted.
            return this.refreshSavedProfile(this._pendingEmailChangeUsername).catch(function(){});
        }).bind(this)).then((function(){
            const currentUserInfo = LocalStorageHelper.getInstance().getUserInfo();
            this.view.closeEmailChangeVerificationPanel();
            this.view.setEmail(currentUserInfo ? currentUserInfo.email : "");
            // Revalidate rather than enable Save: other fields may have been made invalid meanwhile.
            this.validateForm();
        }).bind(this), (function(error){
            const errorMessage = error && (error.errorMessage || error.message) ?
                (error.errorMessage || error.message) : window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHEN_SAVING_YOUR_CHANGES");
            this.view.setEmailChangeVerificationError(errorMessage);
            this.view.setEmailChangeVerificationButtonEnabled(true);
        }).bind(this));
    },

    validateForm : function(){
        const formData = this.view.getFormData();
        this.view.setSaveButtonEnabled(false);
        this.view.setFormBeingValidated(true);
        const promiseHash = {};

        promiseHash["validatUsername"] = this.validatUsername(formData.username);
        promiseHash["validateFullNameField"] = RSVP.Promise.resolve(this.view.validateFullNameField());
        promiseHash["validateBioField"] = RSVP.Promise.resolve(this.view.validateBioField());
        promiseHash["validateWebsiteField"] = RSVP.Promise.resolve(this.view.validateWebsiteField());
        promiseHash["validatEmail"] = this.validatEmail(formData.email);
        return RSVP.hash(promiseHash).then((function(results){
            const formValidation = results.validatUsername &&  results.validateFullNameField && results.validateBioField && results.validateWebsiteField  && results.validatEmail;
            this.view.setFormBeingValidated(false);
            this.view.setSaveButtonEnabled(formValidation);
            return formValidation;
        }).bind(this)).catch(function(error){
            this.view.setFormBeingValidated(false);
            this.view.setSaveButtonEnabled(false);
            window.alertErrorMessage(error? error:window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHEN_SAVING_YOUR_CHANGES"));
        });


    },
    

    buildModelAndRenderView : function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                
                const pageViewParams= {};
                pageViewParams.pageId = this._pageId;
                pageViewParams.userInfoJson = LocalStorageHelper.getInstance().getUserInfo();
                this.model = Utils.getInstance().getModelFromUserJson(pageViewParams.userInfoJson);
                this.view = new EditUserInfoPageView(pageViewParams);
                this.view.render();
                this.listenTo(this.view, "saveChanges", this.saveChanges);
                this.listenTo(this.view, "validateForm", this.validateForm);
                this.listenTo(this.view, "verifyEmailChange", this.verifyEmailChange);
                this.listenTo(this.view, "cancelEmailChange", this.cancelEmailChange);
                resolve(this);
            } catch (error) {
                reject(error);
            }

        }).bind(this));

    }
    

});
export default EditUserInfoPageController;
